import * as React from "react";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { Link } from "@material-ui/core";
import avatarFooter from "../../assets/images/icon-footer.png";

export function NtnFooter(props) {
  return (
    <div style={{ width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          p: 1,
          m: 1,
          bgcolor: props.theme.palette.primary.main,
          borderRadius: 1,
        }}
      >
        <Box>
          <div style={{ width: "100%" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                p: 1,
                m: 1,
                bgcolor: props.theme.palette.primary.main,
                borderRadius: 1,
              }}
            >
              <Box sx={{ marginRight: "5%", marginTop: "6%" }}>
                <img
                  src={avatarFooter}
                  style={{ height: "80px", width: "80px" }}
                />
              </Box>
              <Box>
                <Link
                  color={props.theme.palette.secondary.main}
                  href="http://reclamation.portnet.ma/index.php?page=citoyen.AccueilCitoyen&atexoDemande=7be87818f103db72a5da7f169f0d6920"
                  target="_blank"
                  rel="noopener"
                >
                  <h3
                    style={{
                      color: props.theme.palette.secondary.main,
                      marginBottom: "0px",
                    }}
                  >
                    http://reclamation.portnet.ma
                  </h3>
                </Link>
                <h2
                  style={{
                    color: props.theme.palette.secondary.main,
                    marginTop: "0px",
                    marginBottom: "0px",
                  }}
                >
                  05 20 473 100
                </h2>
                <Link
                  href="https://portail.portnet.ma/fr/guides-utilisateurs"
                  underline="none"
                  target="_blank"
                  rel="noopener"
                >
                  <Typography
                    variant="h6"
                    style={{
                      color: props.theme.palette.secondary.main,
                      marginTop: "0px",
                      marginBottom: "1.5%",
                    }}
                  >
                    Guides utilisateurs
                  </Typography>
                </Link>
              </Box>
            </Box>
          </div>
        </Box>
        <Box sx={{ marginTop: "3%" }}>
          <Typography
            style={{
              color: props.theme.palette.secondary.main,
              marginTop: "2px",
              marginBottom: "0.5%",
            }}
          >
            Copyright © 2022, PORTNET.SA.
          </Typography>
        </Box>
        <Box sx={{ marginRight: "1%" }}>
          <h3 style={{ color: props.theme.palette.secondary.main }}>
            Rejoignez-nous{" "}
          </h3>
          <a href="https://www.linkedin.com/company/portnet/" target="_blank">
            <LinkedInIcon sx={{ color: props.theme.palette.secondary.main }} />
          </a>
          <a href="https://twitter.com/PORTNETSA" target="_blank">
            <TwitterIcon sx={{ color: props.theme.palette.secondary.main }} />
          </a>
          <a
            href="https://www.facebook.com/PORTNETSA?_rdc=1&_rdr"
            target="_blank"
          >
            <FacebookIcon sx={{ color: props.theme.palette.secondary.main }} />
          </a>
          <a
            href="https://www.youtube.com/channel/UC9vtz2NXQbiVAZ4rFPSOJtA"
            target="_blank"
          >
            <YouTubeIcon sx={{ color: props.theme.palette.secondary.main }} />
          </a>
          <a href="https://www.instagram.com/portnet_officiel/" target="_blank">
            <InstagramIcon sx={{ color: props.theme.palette.secondary.main }} />
          </a>
        </Box>
      </Box>
    </div>
  );
}
